import { Link, useLocation } from "react-router-dom";
import { useCookieConsent } from "@/hooks/useCookieConsent";

export function Footer() {
  const { clearConsent } = useCookieConsent();
  const { pathname } = useLocation();

  // Hide footer on focused study surfaces — legal links shouldn't compete
  // with questions or the Tending Flow's contained world.
  // Routes: /test/:courseId, /course/:courseId/topic-quiz/:topicId,
  //         /course/:courseId/tend/:topicId
  const isFocusedSurface =
    /^\/test\/[^/]+$/.test(pathname) ||
    /^\/course\/[^/]+\/topic-quiz\/[^/]+$/.test(pathname) ||
    /^\/course\/[^/]+\/tend\/[^/]+$/.test(pathname);

  if (isFocusedSurface) {
    return null;
  }

  return (
    <footer
      className="relative z-40 mt-auto w-full"
      style={{
        // Barely-there frosted strip — enough to lift text off busy tropical bg, not a brown bar.
        // 35% cream tint with strong blur so foliage shows through but text reads.
        background: "hsl(48 70% 94% / 0.35)",
        backdropFilter: "blur(12px) saturate(1.1)",
        WebkitBackdropFilter: "blur(12px) saturate(1.1)",
        borderTop: "1px solid hsl(140 25% 55% / 0.25)",
        borderRadius: "0",
      }}
    >
      <div className="max-w-5xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-4 text-shadow-footer">

        {/* Left: wordmark + copyright */}
        <div className="flex flex-col items-center sm:items-start gap-0.5">
          <span className="text-sm font-bold tracking-tight text-ghibli-canopy">
            PassAI
          </span>
          <span className="text-xs text-ghibli-bark">
            © 2026 Shryn, Inc.
          </span>
        </div>

        {/* Right: legal links */}
        <nav
          aria-label="Legal links"
          className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[13px] font-medium text-ghibli-bark"
        >
          <Link
            to="/privacy"
            className="hover:text-ghibli-jungle transition-colors"
          >
            Privacy Policy
          </Link>
          <span aria-hidden className="opacity-40">·</span>
          <Link
            to="/terms"
            className="hover:text-ghibli-jungle transition-colors"
          >
            Terms of Service
          </Link>
          <span aria-hidden className="opacity-40">·</span>
          <Link
            to="/cookies"
            className="hover:text-ghibli-jungle transition-colors"
          >
            Cookie Policy
          </Link>
          <span aria-hidden className="opacity-40">·</span>
          <a
            href="mailto:passai.study@gmail.com"
            className="hover:text-ghibli-jungle transition-colors"
          >
            Contact
          </a>
          <span aria-hidden className="opacity-40">·</span>
          <button
            onClick={clearConsent}
            className="hover:text-ghibli-jungle transition-colors underline-offset-2 hover:underline cursor-pointer"
          >
            Cookie Settings
          </button>
        </nav>
      </div>
    </footer>
  );
}
